import React, { useState } from 'react';
import { MDBContainer, MDBRow, MDBCol } from 'mdbreact';
import { useDispatch } from 'react-redux';
import { LOGIN_SUCCESS } from '../../redux/types/actions';
import { useHistory } from 'react-router-dom';
import { Button, Card, Input } from 'react-rainbow-components';
import logo from '../../images/logos/logo.webp'


const Login: React.FC = () => {

    const [username, setusername] = useState<string>('')
    const [password, setPassword] = useState<string>('')
    const [error, setError] = useState<String>('')
    const [loading, setLoading] = useState<boolean>(false)
    const history = useHistory();
    const dispatch = useDispatch();

    const login = async () => {
        //reset error message to empty
        setError("");

        //set loading state for the button
        setLoading(true)
        const RequestInit = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: "include",
            body: JSON.stringify({ username: username, password: password })
        };

        await fetch('https://admin.radioemotion.be/api/login', RequestInit as RequestInit)
            .then(response => response.json())
            .then(response => {
                setLoading(false)
                if (response.response === true) {
                    dispatch({
                        type: LOGIN_SUCCESS,
                        payload: {
                            username: response.data.username, adminRole: response.data.adminRole
                        }
                    });
                    history.push('/')
                } else {
                    setError("Nom d'utilisateur ou mot depasse incorrecte")
                }
            })
            .catch(err => {
                console.log("err");
                setLoading(false)
                setError("un problème est survenu lors de l'envoie");
            })
    }

    return (
        <>
            <MDBContainer className="min-h-100vh">
                <MDBRow className="min-h-100vh justify-content-center align-content-center align-middle">
                    <MDBCol md="4" sm="8">
                        <Card>
                            <MDBCol size={"8"} className="offset-2">
                                <img
                                    src={logo}
                                    alt="logo of radio emotion"
                                    className="mt-4 mb-4"
                                />
                            </MDBCol>
                            <MDBCol size={"10"} className="offset-1 mb-2 mt-2">
                                <Input
                                    label="Nom d'utilisateur"
                                    placeholder="Entrez votre nom d'utilisateur"
                                    type="text"
                                    isCentered={true}
                                    className="mb-4"
                                    onChange={(event) => setusername(event?.currentTarget?.value)}
                                    value={username}
                                />
                            </MDBCol>
                            <MDBCol size={"10"} className="offset-1 mb-2">
                                <Input
                                    isCentered={true}
                                    label="Mot de passe"
                                    placeholder="**********"
                                    type="password"
                                    className="mb-4"
                                    onChange={(event) => setPassword(event?.currentTarget?.value)}
                                    value={password}
                                />
                            </MDBCol>
                            {error !== undefined ? <MDBCol> <p className="red-text text-center font-weight-bold">{error}</p></MDBCol> : <MDBCol></MDBCol> }
                            <MDBCol size={"10"} className="offset-1 mb-4">
                                <Button
                                    isLoading={loading}
                                    label="Connecter"
                                    onClick={() => login()}
                                    variant="brand"
                                    className='w-100 mt-2'
                                />
                            </MDBCol>
                        </Card>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        </>
    );
}

export default Login;
